// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HNuX","controls":"styles_controls__6C4ss","charLimit":"styles_charLimit__DccZ-","input":"styles_input__2VWOA","send":"styles_send__kSYSb"};